import IApplicationEmail from '~Api/ApplicationEmail/IApplicationEmail';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import { keyMap } from '~utilities/utils';

export function applicationEmailSelector(state: IGlobalState, applicationEmailUuid: string): IApplicationEmail {
    return state.applicationEmails.emails[applicationEmailUuid];
}

export function applicationEmailsPageSelector(state: IGlobalState, applicationUuid: string): IDictionary<IApplicationEmail> {
    if (!state.applicationEmails.pageEmailUuids[applicationUuid]) {
        return null;
    }

    return keyMap(state.applicationEmails.pageEmailUuids[applicationUuid], 'uuid', (applicationEmailUuid: string): IApplicationEmail => applicationEmailSelector(state, applicationEmailUuid));
}

export function applicationEmailsPageNumberSelector(state: IGlobalState, applicationUuid: string): number {
    return state.applicationEmails.pageNumbers[applicationUuid];
}

export function applicationEmailsCountSelector(state: IGlobalState, applicationUuid: string): number {
    return state.applicationEmails.pageCounts[applicationUuid];
}

export function applicationEmailTextSelector(state: IGlobalState, applicationEmailUuid: string): string {
    return state.applicationEmails.texts[applicationEmailUuid];
}
